import React, { Component, Fragment } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
    FormWrapperInputComponent,
    FormWrapperItem,
    StatusComponent,
    ListComponent
} from "../../../common/component/Index";
import { Icon, Checkbox, Button, Cascader, Tooltip, InputNumber, Switch, message, Alert, Table, Radio } from 'antd';
import Modal from '../../../common/component/Modal';
import Input from '../../../common/component/Input';
import { isEqual, get, find, toArray, groupBy, findIndex, cloneDeep, isEmpty, omit } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import RateCode, { RateCodeProduct } from '../../../../../models/RateCode';
import { INTEREST_UNIT_TYPE, PATHS, RATECODE, SUPPLIER } from '../../../../../constants/Define';
import AntSelect, { AntOption } from '../../../common/component/AntSelect';
import Wrapper from '../../../common/component/Wrapper';
import Empty, { PRESENTED_IMAGE_SIMPLE } from '../../../common/component/Empty';
import Span from '../../../common/component/Span';
import EllipsisText from '../../../common/component/EllipsisText';
import './RateCodeDetail.less';
import StockAvailableTable from './components/StockAvaillableTable/StockAvailableTable';
import classNames from 'classnames';
import Collapse, { Panel } from '../../../common/component/Collapse';
import { HeaderComponent } from '../../../common/component/Index';
import RenderInventoryDeliveryType from './RenderInventoryDeliveryType';
import { getRateCodeInventorydelivery, syncRateCodeSlotServices } from '../../../../../services/rateCodeService';
import MultiLanguageInput, { DEFAULT_LANGUAGE_CODE, getDefaultTranslation } from './components/MultiLanguageInput';
import SlotServices from './components/SlotServices';
import moment from 'moment';

const CheckboxGroup = Checkbox.Group

const columns = [
    {
      title: "Sản phẩm",
      dataIndex: "product",
      align: "center"
    },
    {
      title: "Đơn giá",
      align: "center",
      dataIndex: "unitPrice"
    },
    {
      title: "Số lượng",
      align: "center",
      dataIndex: "quantity"
    },
    {
      title: "Thành tiền",
      align: "center",
      dataIndex: "price"
    }
  ];

const defaultState = {
    action: "CREATE",
    validation: {},
};

const ListCols = ['name', 'inventoryDeliveryType', 'cost', 'coefficient', 'interest', 'sellCost', 'id', 'isAddNew'];
class RateCodeProducts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            titleItemTable: Func.getTitleTable(ListCols, ['action'], ['id', 'isAddNew']),
            componentTable: {
                inventoryDeliveryType: {
                    key: 'inventoryDeliveryType',
                    align: "center",
                    render: (inventoryDeliveryType, rec, index) => {
                     return <RenderInventoryDeliveryType
                        dataInventory={inventoryDeliveryType}
                        dataCheckNaN = {this.state.productType}
                        isDisabled={this.state.action === 'UPDATE' && !rec.isAddNew}
                        supplierProductCode={this.state.arrProduct?.[index]?.code}
                        onChangeInventoryType={value => this.onChangeItemInterest(index, 'inventoryDeliveryType', value)}
                        error={this.state.errorRowProduct?.[index]}
                        />
                    }
                },  
                cost: {
                    key: 'cost',
                    align: "right",
                    render: (cost) => Func.formatMoney(cost)
                },
                interest: {
                    key: 'interest',
                    align: 'left',
                    width: 250,
                    render: (interest, record, idx) => 
                        <InputNumber 
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            style={{width: '100%'}}
                            value={ Func.checkUndefine(interest) }
                            onChange={(e)=> this.onChangeItemInterest(idx, 'interest', e)}
                            min={0}
                        />
                },
                sellCost: {
                    key: 'sellCost',
                    align: "right",
                    render: (sellCost) => Func.formatMoney(sellCost)
                },
                action: {
                    width: 100,
                    key: 'action',
                    align: 'center',
                    render: (text, record, idx)=> <Icon type="delete" style={{cursor: 'pointer'}} onClick={()=>this.removeItem(idx)}/>
                }
            },
            arrProduct: [],
            supplierItem: undefined,
            name: null,
            inventoryDeliveryType: 0,
            supplierProductItem: null,
            cost: null,
            coefficientItem: 1,
            interest: 0,
            code: null,
            productCode: null,
            supplierCategoryCode: null,
            isPopupSchedule: false,
            inventoryType: 'Mỗi ngày trong lịch trình',
            productType: null,
            supplierType: null,
            errorRowProduct: []
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.arrCodeProducts && !isEqual(nextProps.arrCodeProducts, this.props.arrCodeProducts)) {
            this.setState({
                arrProduct: nextProps.arrCodeProducts,
                action: nextProps.rateCodeState.rateCodeDetail.id ? 'UPDATE' : this.state.action
            });
        }
        if (nextProps.errorRowProduct && !isEqual(nextProps.errorRowProduct, this.props.errorRowProduct)){
            this.setState({errorRowProduct: nextProps.errorRowProduct})
        }
    }

    getSelectOptions = () => {
        const { t, supplierState, supplierCategoryState } = this.props;
        const { supplierProducts } = supplierState;
        const { supplierCategoryAll } = supplierCategoryState;
        const { supplierItem } = this.state;
        let arrSupProduct = supplierProducts;
        if(supplierItem){
            arrSupProduct = supplierProducts.filter(item => item.supplierId === supplierItem);
        }
        const groupedProducts = groupBy(arrSupProduct, (item) => {
            return item.categoryId;
        });
        const result = [];
        Object.keys(groupedProducts).forEach(typeKey => {
            let findIndex = supplierCategoryAll.findIndex(cate => cate.id === typeKey);
            if (findIndex > -1) {
                result.push({
                    value: supplierCategoryAll[findIndex].id,
                    label: <EllipsisText title={supplierCategoryAll[findIndex].name} content={supplierCategoryAll[findIndex].name} 
                        contentMaxWidth={280} overlayClassName={'max-width-500'} overlayComponent={Tooltip} 
                    />,
                    text: supplierCategoryAll[findIndex].name,
                    children: (groupedProducts[typeKey] || []).map(prod => ({
                        value: prod.id,
                        label: this.renderProductItem(prod),
                        text: prod.name,
                        product: prod,
                        code: supplierCategoryAll[findIndex].code
                    })),
                    supplierCategoryCode: supplierCategoryAll[findIndex].code
                })
            }
        });
        return result;
    }

    renderProductItem = (product) => {
        return (
            <Span key={product.id} className="select-supplier-product-item">
                {product.name} - {product.supplierName} <Span className="button-section">
                </Span>
            </Span>
        )
    }

    selectFilterSearch = (input, path) => {
        return path.some(option => {
            const optionText = Func.vietnameseStringToUnicode(option.text.toLowerCase());
            const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
            return optionText.indexOf(inputText) >= 0;
        })
    };

    selectFilterSearchAnt = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(option.props.children.toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    };

    renderSearchResults = (inputValue, path) => {
        return <Span>{path.map(p => p.text).join(' / ')}</Span>
    }

    sortSearchResult = (a, b, inputValue) => {
        const inputText = Func.vietnameseStringToUnicode(inputValue.toLowerCase());
        const aText = Func.vietnameseStringToUnicode(a.map(item => item.text).join(' / ').toLowerCase());
        const bText = Func.vietnameseStringToUnicode(b.map(item => item.text).join(' / ').toLowerCase());
        return aText.indexOf(inputText) > bText.indexOf(inputText)
    }

    onChangeSupplierProduct = (values)=>{
        this.setState({supplierProductItem: values});
        // let id = values[1];
        const [idCategory, idSupplierProduct] = values
        const { supplierState, supplierCategoryState } = this.props;
        const { supplierProducts } = supplierState;
        const { supplierItem } = this.state;
        const { supplierCategoryAll } = supplierCategoryState;
        if(idSupplierProduct){
            const selectedIndex = findIndex(supplierProducts, type => type.id === idSupplierProduct);
            const selectedCategoryIndex = findIndex(supplierCategoryAll, category => category.id === idCategory);
            if(selectedIndex > -1){
                this.setState({
                    cost: supplierProducts[selectedIndex].cost, 
                    productCode: supplierProducts[selectedIndex].productCode,
                    name: supplierProducts[selectedIndex].name,
                    supplierCategoryCode: supplierCategoryAll[selectedCategoryIndex].code,
                    
                });
                // if(!supplierItem){
                //     this.onChangeItem("supplierItem", supplierProducts[selectedIndex].supplierId)
                // }
            }
        }
        
    }

    onChangeItem = (fieldName, value)=>{
        this.setState({[fieldName]: value});
        if(fieldName === 'supplierItem'){
            const { supplierState } = this.props;
            const { supplierAll } = supplierState;
            const supplier = supplierAll.find((e) => e.id === value);
            this.setState({
                supplierProductItem: null,
                name: null,
                cost: null,
                productCode: null,
                supplierType: supplier?.supplierType || "",
            });
        }
    }

    onChangeItemInterest = (idx, fieldName, value)=>{
        const { arrProduct } = this.state;
        arrProduct[idx][fieldName] = value;
        this.setState( { arrProduct });
        this.onCalculatorMoney(idx);
    }

    onCalculatorMoney = (idx = -1)=>{
        const { arrProduct } = this.state;
        const { interestUnitType } = this.props.rateCode;
        if(arrProduct && arrProduct.length > 0){
            if(idx > -1){
                let costTmp = (arrProduct[idx]['coefficient'] || 1)*arrProduct[idx]['cost'];
                if(interestUnitType === 1){ //Money
                    costTmp = costTmp + arrProduct[idx]['interest'];
                }else{ //Percent
                    costTmp = costTmp* (1 + 0.01*arrProduct[idx]['interest']);
                }
                arrProduct[idx]['sellCost'] = Math.round(costTmp);
                this.setState( { arrProduct });
                this.props.addNewProduct(arrProduct);
            }else{
                let arrHandle = arrProduct.map((item)=>{
                    let costTmp = (item.coefficient || 1)*item.cost;
                    if(interestUnitType === 1){ //Money
                        costTmp = costTmp + item.interest;
                    }else{ //Percent
                        costTmp = costTmp* (1 + 0.01*item.interest);
                    }
                    return{
                        ...item,
                        sellCost:  Math.round(costTmp)
                    }
                });
                this.setState( { arrProduct: arrHandle });
                this.props.addNewProduct(arrHandle);
            }
        }
        
    }

    onChangeSwitch = (fieldName, value)=> {
        this.props.changeInterest(fieldName, value ? 1 : 2);
        this.onCalculatorMoney();
    }

    removeItem = (idx)=>{
        const { arrProduct } = this.state;
        if(idx !== null){
            arrProduct.splice(idx, 1);
            this.setState({arrProduct})
            this.props.addNewProduct(arrProduct);
        }
    }

    addNewRowProduct = async ()=>{
        const {
            supplierItem,
            inventoryDeliveryType,
            supplierProductItem,
            coefficientItem,
            arrProduct,
            name,
            cost,
            productCode,
            interest,
            supplierCategoryCode, supplierType
        } = this.state;
        if(supplierProductItem && supplierProductItem.length > 0 && coefficientItem){
            let findProductHasLTR = arrProduct.findIndex(item => item.supplierCategoryCode === 'LTR')
            // const indexCodeItem = arrProduct.findIndex(item => item.supplierCategoryCode === supplierCategoryCode) 
            let findProduct = arrProduct.find(item => item.supplierProductId === supplierProductItem[1])
            let isRequired = false;
            if((findProductHasLTR > -1 && supplierCategoryCode === 'LTR') || findProduct) {
                return message.error(this.props.t('validation.statusCode.code.CATEGORY_VALIDATION_ERROR'))
            }
            if (supplierType !== 7) {
                try {
                    const response = await getRateCodeInventorydelivery(productCode);
                    isRequired = response.data.data;
                } catch (error) {
                    if(error?.data.errors[0].code === 'WH_NOT_RECEIPT') {
                        return message.error(this.props.t('validation.statusCode.code.WH_NOT_RECEIPT'))
                    }
                }
            }
            let newItem = new RateCodeProduct({
                name: name|| null,
                id: supplierItem || null,
                code: productCode,
                inventoryDeliveryType: inventoryDeliveryType,
                supplierProductId: supplierProductItem[1],
                coefficient: coefficientItem || 1,
                interest: interest || 0,
                cost: cost,
                sellCost: (coefficientItem || 1)*cost,
                supplierCategoryCode: supplierCategoryCode,
                isRequired,
                isAddNew: true
            })
            let newArr = [
                newItem,
                ...arrProduct,
            ]
            this.setState({arrProduct: newArr});
            this.props.addNewProduct(newArr);

            // get stock available quantity
            this.props.getStockProducts({codes: [productCode]});
        }
    }

    render(){
        const {
            componentTable,
            titleItemTable,
            supplierItem,
            supplierProductItem,
            coefficientItem,
            arrProduct,
            interest
        } = this.state;

        const { t, supplierState} = this.props;
        const {action} = this.state;
        const { supplierAll } = supplierState;
        let isDisabledAdd = true;
        if(supplierProductItem && supplierProductItem.length > 0 && coefficientItem){
            isDisabledAdd = false;
        }
        return (
            <div className="ratecode-detail-page">
                <Wrapper className="row m-0">
                    <Wrapper className="col-md-4 p-0">
                        <AntSelect className="select-types"
                            showArrow showSearch
                            placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.ratecode.product.supplier")).toLowerCase()) }
                            value={ supplierItem }
                            filterOption={this.selectFilterSearchAnt}
                            onChange={ sp => this.onChangeItem('supplierItem', sp) }
                            style={ { width: '100%' } }
                            allowClear
                        >
                            { (supplierAll || []).map(sp => (
                                <AntOption key={ sp.id } value={ sp.id }>
                                    { sp.supplierName }
                                </AntOption>
                            )) }
                        </AntSelect>
                    </Wrapper>
                    <Wrapper className="col-md-5">
                        <Cascader
                            style={{ width: '100%' }}
                            value={supplierProductItem}
                            placeholder={t(`item.supplier.selectSupplierProducts`)}
                            options={this.getSelectOptions()}
                            showSearch={{ filter: this.selectFilterSearch, render: this.renderSearchResults, sort: this.sortSearchResult }}
                            expandTrigger="hover" allowClear
                            onChange={this.onChangeSupplierProduct}
                            notFoundContent={<Empty image={PRESENTED_IMAGE_SIMPLE} />}
                            displayRender={(label, selectedOptions) => selectedOptions.map(item => item.text).join(' / ')}
                        />
                    </Wrapper>
                    <Wrapper className="col-md-2 inputNumber-center-add">
                        <span className="coefficient-title">Hệ số</span>
                        <InputNumber 
                            style={{width: '100%'}}
                            value={ Func.checkUndefine(coefficientItem) }
                            onChange={(e)=> this.onChangeItem('coefficientItem', e)}
                            min={0}
                        />
                    </Wrapper>
                    <Wrapper className="col-md-1 p-0 button-center-add">
                        <Button disabled={isDisabledAdd} type="primary" onClick={this.addNewRowProduct}>{t(`item.ratecode.product.add`)}</Button>
                    </Wrapper>
                    <Wrapper className="row m-0 switch-interest-ratecode">
                        <Switch 
                            checked={ this.props.rateCode.interestUnitType === 1 ? true : false } 
                            checkedChildren={'$'}
                            unCheckedChildren={'%'}
                            onChange={ check => this.onChangeSwitch('interestUnitType', check) }
                        />
                        <div className="text-interest-ratecode">Lãi tính theo {this.props.rateCode.interestUnitType === 1 ? '$' : '%'}</div>
                    </Wrapper>
                </Wrapper>
                
                <ListComponent 
                    className="list-product-schedule"
                    tableKey="room-type-list"
                    classChildren="p-0" classParent="m-0"
                    rowKey={(record, k) => record.supplierProductId ? record.supplierProductId : k}
                    loading={{ spinning: false, size: 'large' }}
                    dataSource={ Func.getDataSource(arrProduct || [], ListCols) }
                    columns={Func.columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'ratecode.product'
                    })}
                />
            </div>
        )
    }
}

export default class RateCodeDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            rateCode: this.props.rateCodeState.rateCodeDetail,
            rateCodeCampaign: null,
            surchargeCategory: null,
            isShowAddModal: false,
            isShowAddModalSurcharge: false,
            isErrorCost: true,
            typeCheckCode: false,
            isShowVinwonderTypeForUpdate: true,
            isShowBasicTypeForUpdate: true,
            isAddNewSchedule: false,
            valuePriceAddNewSchedule: { "0": 0 },
            newRateCodeSchedule: {},
            errorRateCodeSchedule: {lengOfStay: '', rateCodeProduct: []},
            errorRowProduct: [],
            isSyncingSlotServices: false
        };
    }

    componentDidMount() {
        this.initDetail()
    }

    componentWillUnmount() {
        this.props.setRateCodeDetail(new RateCode({adult: 2,child: 1,room: 1,lengOfStay: 1}))
        this.props.setRateCodeSchedule([]);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.rateCodeState.rateCodeDetail && !isEqual(nextProps.rateCodeState.rateCodeDetail, this.props.rateCodeState.rateCodeDetail)) {
            const rateCodeDetail = nextProps.rateCodeState.rateCodeDetail;
            const defaultTranslation = getDefaultTranslation(rateCodeDetail.translations || []);
            if (defaultTranslation) {
                rateCodeDetail.name = defaultTranslation.name || rateCodeDetail.name;
                rateCodeDetail.description = defaultTranslation.description ?? rateCodeDetail.description;
            }
            this.setState({
                rateCode: rateCodeDetail,
                action: rateCodeDetail.id ? 'UPDATE' : this.state.action
            });

            // check to allow change product type
            const isShowVinwonderTypeForUpdate = nextProps?.rateCodeState?.rateCodeDetail?.id 
            && (nextProps?.rateCodeState?.rateCodeDetail?.productTypes || []).indexOf(RATECODE.GROUP_TYPE_VINWONDER.VINWONDER.id) > -1;
            this.setState({isShowVinwonderTypeForUpdate: isShowVinwonderTypeForUpdate});

            const isShowBasicTypeForUpdate = nextProps?.rateCodeState?.rateCodeDetail?.id 
            && (nextProps?.rateCodeState?.rateCodeDetail?.productTypes || []).indexOf(RATECODE.GROUP_TYPE_VINWONDER.VINWONDER.id) === -1;
            this.setState({isShowBasicTypeForUpdate: isShowBasicTypeForUpdate});
        }

        // set stock available quantity
        if (nextProps.rateCodeState.stockProducts?.length && !isEqual(nextProps.rateCodeState.stockProducts, this.props.rateCodeState.stockProducts)) {
            const stockProducts = nextProps.rateCodeState.stockProducts;
            const { rateCode } = this.state;
            if(rateCode?.rateCodeProducts?.length){
                const newRateCodeProducts = cloneDeep(rateCode.rateCodeProducts);
                stockProducts.map(item => {
                    newRateCodeProducts.filter(x=>x.code === item.materialCode).forEach(x=>{
                        x.stockAvailable = item.stockAvailableQty || 0;
                    });
                });
                
                this.setState({ rateCode: { ...this.state.rateCode, rateCodeProducts: newRateCodeProducts } });
            }

        }
    }

    getGroupTypeDefind = ()=>{
        return toArray(RATECODE.GROUP_TYPE);
    }

    getGroupTypeVinwonder = ()=>{
        return toArray(RATECODE.GROUP_TYPE_VINWONDER);
    }

    onAddItem = (e) => {
        this.setState({ isShowAddModal: true, })
    }

    onAddItemSurcharge = () => {
        this.setState({ isShowAddModalSurcharge: true, })
    }

    addRateCodeCampaign = ()=>{
        const {
            rateCodeCampaign
        } = this.state;
        if(rateCodeCampaign){
            this.props.createRateCodeCampaign({name: rateCodeCampaign});
            this.setState({isShowAddModal: false});
        }
    }

    addSurchargeCategory = () => {
        const {
            surchargeCategory
        } = this.state;
        if(surchargeCategory){
            this.props.createSurchargeCategories({name: surchargeCategory});
            this.setState({isShowAddModalSurcharge: false});
        }
    }

    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(option.props.children.toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    }
    
    renderAddCampaignModal = ()=>{
        const { t } = this.props;
        const { isShowAddModal, rateCodeCampaign } = this.state;
        return (
            <Modal
                visible={isShowAddModal}
                title={`${t('action.create')} ${Func.capitalizeFirstLetter(t('item.ratecode.campaign')).toLowerCase()}`}
                // okText={editSupplierProduct && editSupplierProduct.id ? t('action.update') : t('action.create')} cancelText={t('action.cancel')}
                // okButtonProps={{ disabled: !editSupplierProduct || !editSupplierProduct.name || editSupplierProduct.type === undefined }}
                onOk={this.addRateCodeCampaign}
                onCancel={() => this.setState({ isShowAddModal: false})}
            >
                <Span className="text-body">{t('item.ratecode.campaign')}<Span className="colorRed">*</Span></Span>
                <Input value={rateCodeCampaign}
                    autoFocus 
                    className="mt-1 mb-3"
                    onChange={e => {
                        this.setState({ rateCodeCampaign: e.target.value })
                    }}
                />
            </Modal>
        )
    }

    renderAddSurchargeCategoryModal = () => {
        const { t } = this.props;
        const { isShowAddModalSurcharge, surchargeCategory } = this.state;
        return (
            <Modal
                visible={isShowAddModalSurcharge}
                title={`${t('action.create')} ${Func.capitalizeFirstLetter(t('item.ratecode.surchargeCategory')).toLowerCase()}`}
                // okText={editSupplierProduct && editSupplierProduct.id ? t('action.update') : t('action.create')} cancelText={t('action.cancel')}
                // okButtonProps={{ disabled: !editSupplierProduct || !editSupplierProduct.name || editSupplierProduct.type === undefined }}
                onOk={this.addSurchargeCategory}
                onCancel={() => this.setState({ isShowAddModalSurcharge: false})}
            >
                <Span className="text-body">{t('item.ratecode.surchargeCategory')}<Span className="colorRed">*</Span></Span>
                <Input value={surchargeCategory}
                    autoFocus 
                    className="mt-1 mb-3"
                    onChange={e => {
                        this.setState({ surchargeCategory: e.target.value })
                    }}
                />
            </Modal>
        )
    }

    renderProductList = (props) => {
        const dataProductList = props.rateCodePlans.map((el) => (
            {
                product: el.name,
                unitPrice: Func.formatMoney(el.cost),
                quantity: el.coefficient,
                price: Func.formatMoney(el.sellCost)
            }
        ))
        const totalPriceProductList = props.rateCodePlans.reduce((total, currentValue) => {
            return total + currentValue.sellCost
        }, 0)
        return (
          <Wrapper className=" row">
            <Wrapper className="col-md-12 col-sm-12 col-xs-12">
                <div className='table-schedule'>
                    <Table
                        pagination={false}
                        columns={columns}
                        dataSource={dataProductList}
                        bordered
                    />
                    <div className="total-price">Total: {Func.formatMoney(totalPriceProductList)}</div>
                </div>
            </Wrapper>
          </Wrapper>
        );
    };

    onchangeLengthOfStay = (e) => {
        const rateSchedule = cloneDeep(this.state.newRateCodeSchedule);
        rateSchedule.minimumUnitShedules.lengOfStay=e.target.value
        this.setState({newRateCodeSchedule: rateSchedule});
    }

    onChangeCoefficent = (e, index) => {
        const rateSchedule = this.state.newRateCodeSchedule.rateCodeProduct;
        const currentSchedule = rateSchedule[index];
        rateSchedule[index].coefficient = Number(e.target.value);
        const interestAndCost = currentSchedule.cost * Number(e.target.value) + this.interestAddition(currentSchedule, Number(e.target.value), this.state.rateCode.interestUnitType);
        rateSchedule[index].sellCost = interestAndCost;
        this.setState({newRateCodeSchedule: {...this.state.newRateCodeSchedule, rateCodeProduct: rateSchedule}})
    }

    interestAddition = (currentSchedule, coefficient, interestUnitType = 1) => {
        let interestAndCost = 0;
        if (interestUnitType === INTEREST_UNIT_TYPE.MONEY) {
            interestAndCost = currentSchedule.interest / currentSchedule?.oldCoefficient * Number(coefficient);
        } else {
            interestAndCost = currentSchedule.interest / 100 * currentSchedule.cost * Number(coefficient)
        }
        return interestAndCost;
    }

    recalculatedSchedule = (interestUnitType) => {
        if (isEmpty(this.state.newRateCodeSchedule)) {
            const schedule = {...this.state.newRateCodeSchedule};
            schedule.rateCodeProduct = (this.state.newRateCodeSchedule?.rateCodeProduct || []).map(e => {
                const sellCost = e.cost * Number(e.coefficient) + this.interestAddition(e, e.coefficient, interestUnitType || this.state.rateCode.interestUnitType);
                return {...e, sellCost}
            })
            this.setState({ newRateCodeSchedule: schedule })
        }
    }

    onClickCreateSchedule = () => {
        const { rateCodeState } = this.props;
        const { rateCodeSchedule, rateCodeDetail } = rateCodeState;
        const {newRateCodeSchedule} = this.state;
        const findLengthOfStay = rateCodeSchedule.find(el => el?.lengOfStay === Number(newRateCodeSchedule?.minimumUnitShedules?.lengOfStay))
        let error = { isError: false };
        if (newRateCodeSchedule?.minimumUnitShedules?.lengOfStay < 1) {
            error.lengOfStay = "* Số đêm sẽ bắt đầu từ 1";
            error.isError = true;
        }
        if (newRateCodeSchedule?.minimumUnitShedules?.lengOfStay < rateCodeDetail?.lengOfStay) {
            error.lengOfStay = "* Số đêm phải lớn hơn số đêm mặc định";
            error.isError = true;
        }
        if (findLengthOfStay) {
            error.lengOfStay = "* Số đêm đã tồn tại";
            error.isError = true;
        }
        if (!newRateCodeSchedule?.minimumUnitShedules?.lengOfStay) {
            error.lengOfStay = "* Số đêm không được để trống";
            error.isError = true;
        }
        const errorRateCodeProduct = newRateCodeSchedule.rateCodeProduct.map((e, i) =>{
            if(!e.coefficient || e.coefficient < 0) {
                error.isError = true;
                return '* Số lượng không được để trống'
            }
            return ''
        })
        error = {
            ...error,
            rateCodeProduct: errorRateCodeProduct
        }
        if (error?.isError) {
            this.setState({errorRateCodeSchedule: error})
        } else {
            this.props.createRateCodeSchedule(this.state.newRateCodeSchedule)
            this.setState({ isAddNewSchedule: false })
        }
    }

    renderAddNewSchedule () {
        const dataProductList = this.state.newRateCodeSchedule.rateCodeProduct;
        const totalPriceProductList = this.state.newRateCodeSchedule.rateCodeProduct.reduce((total, currentValue) => {
            return total + currentValue.sellCost
        }, 0)
        const columnAddNewProducts = [
            {title: "Sản phẩm", dataIndex: "name", align: "center" },
            {title: "Đơn giá", dataIndex: "cost", align: "center", render: (cost) => Func.formatMoney(cost)},
            {
                title: "Số lượng",
                align: "center",
                dataIndex: "coefficient",
                render: (coefficient, record, index) => {
                    return (
                        <div>
                            <input 
                                type='number'
                                value={coefficient}
                                min={0}
                                style={{border: "none", borderBottom: "1px solid #ccc", width: "100px", textAlign: "center"}}
                                onChange={(e) => this.onChangeCoefficent(e, index) }
                            />
                            <p className='err-input-number-add-new-schedule'>{this.state.errorRateCodeSchedule?.rateCodeProduct[index]}</p>
                        </div>
                    );
                }
            },
            {
                title: "Thành tiền",
                align: "center",
                dataIndex: "sellCost",
                render: (sellCost, r, i) => <span>{Func.formatMoney(sellCost)}</span>
            }
        ];
      return (
        <Wrapper className="add-new-schedule">
          <Wrapper>
            <h3 className="header-add-new-schedule">Tạo mới kế hoạch</h3>
            <Wrapper>
                <div className='err-input-add-new-schedule'>{this.state.errorRateCodeSchedule?.lengOfStay}</div>
                <Wrapper className="row input-add-new-schedule">
                    <Input placeholder="Số đêm" type={`text`} onChange={this.onchangeLengthOfStay}
                        name="addNewSchedule"
                        value={this.state.newRateCodeSchedule?.minimumUnitShedules?.lengOfStay}
                        className={`col-6 m-l`} />
                </Wrapper>
            </Wrapper>
            <Wrapper className="row">
                <Wrapper className="col-8 table-add-new-schedule">
                <Table
                    pagination={false}
                    columns={columnAddNewProducts}
                    dataSource={dataProductList}
                    bordered
                />
                <div className="total-price">Total: {Func.formatMoney(totalPriceProductList)}</div>
                </Wrapper>
            </Wrapper>
          </Wrapper>
          <Wrapper className="button-add-new-schedule">
            <Button onClick={() => {this.setState({isAddNewSchedule: false})}} className="button-cancel-schedule" type="primary" danger>
              Quay về
            </Button>
            <Button onClick={this.onClickCreateSchedule} className="button-add-schedule" type="primary">
              Tạo mới
            </Button>
          </Wrapper>
        </Wrapper>
      );
    }

    render() {
        const { t, rateCodeState, tourState, supplierCategoryState } = this.props;
        const { rateCodeCampaigns, rateCodeSchedule } = rateCodeState;
        const { action, rateCode, validation, isErrorCost, typeCheckCode } = this.state;
        let costTotal = 0;
        if(rateCode.rateCodeProducts && rateCode.rateCodeProducts.length > 0){
            costTotal = rateCode.rateCodeProducts.reduce((accumulator, currentValue) => {
                return accumulator + (currentValue.sellCost || 0);
            }, 0)
        }
        const rateCodeScheduleWithSellCost = rateCodeSchedule;
        const { tourSurchargeCategories, isTourSurchargeCategoriesFetching } = tourState
        return(
            <LoadingComponent spinning={false}>
                <PageListComponent>
                    {this.renderAddCampaignModal()}
                    {this.renderAddSurchargeCategoryModal()}
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'ratecode'}
                        titleHeader={action === "CREATE"
                            ? Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.ratecode.title')}`).toLowerCase())
                            : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.ratecode.title')}`.toLowerCase()))
                        }

                    />
                    <FormActionComponent
                        onSubmit={this.onSubmit}
                        isGetItem={false}
                        action={action}
                        onClickBack={this.onClickBack}
                        submitButtonRight={true}
                        isDisableAction={rateCodeState.isFetchingCampaign}
                    >
                        <Collapse
                        defaultActiveKey={["rateCodeDetail"]}
                        bordered={false}
                        style={{ width: "100%", background: "#fff" }}
                        expandIconPosition={"right"}
                        className="site-collapse-rate-code-detail"
                        >
                            <Panel
                            key="rateCodeDetail"
                            header={
                                <HeaderComponent
                                title={t("item.ratecode.ratecodeInfo")}
                                className="col-md-12"
                                style={{
                                userSelect: "none",
                                paddingTop: "unset",
                                paddingBottom: "unset",
                                }}
                                />
                            }
                            >
                                <FormWrapperItem>
                                    <Wrapper className="col-md-6">
                                        <FormWrapperInputComponent
                                            labelTitle={
                                                t('item.ratecode.campaign')
                                            }
                                        >
                                            <Span className="flex-center justify-center w100-percent select-ratecode-product">
                                                <AntSelect className="select-types"
                                                    showArrow showSearch
                                                    suffixIcon={<Icon type="search" />}
                                                    filterOption={this.selectFilterSearch}
                                                    placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.ratecode.campaign")).toLowerCase()) }
                                                    value={ rateCode.campaign?.id }
                                                    onChange={ campaign => this.onChange('campaign', campaign) }
                                                    style={ { width: '100%' } }
                                                >
                                                    { (rateCodeCampaigns || []).map(item => (
                                                        <AntOption key={ item.id } value={ item.id }>
                                                            { item.name }
                                                        </AntOption>
                                                    )) }
                                                </AntSelect>
                                                <Tooltip title={`${t('action.create')} ${t('item.ratecode.campaign').toLowerCase()}`}>
                                                    <Button type="primary" icon="plus" className="btn-add" onClick={this.onAddItem} />
                                                </Tooltip>
                                            </Span>
                                        </FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className='col-md-6'>
                                        <FormWrapperInputComponent
                                            isRequired={ true }
                                            isValidation={ true }
                                            dataValidation={ rateCode.code }
                                            validation={ validation.code }
                                            labelTitle={ t(`item.ratecode.codeTitle`) }
                                        >
                                            <Input type="text"
                                                autoComplete="off"
                                                placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.input') + " " + t("item.ratecode.codeTitle")).toLowerCase()) }
                                                className="form-control" 
                                                name="code" 
                                                onChange={ (e) => this.onChange('code', e.target.value) }
                                                value={ rateCode.code ? rateCode.code : "" }
                                            />
                                            { typeCheckCode && <span style={{color: 'red'}}>{action === 'CREATE' ? t("item.ratecode.invalidCode") : t("item.ratecode.invalidCodeUpdate")}</span>}
                                        </FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className="col-md-6">
                                        <FormWrapperInputComponent
                                            labelTitle={
                                                t('item.ratecode.surchargeCategory')
                                            }
                                        >
                                            <Span className="flex-center justify-center w100-percent select-ratecode-product">
                                                <AntSelect className="select-types"
                                                    showArrow showSearch
                                                    suffixIcon={<Icon type="search" />}
                                                    filterOption={this.selectFilterSearch}
                                                    placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.ratecode.surchargeCategory")).toLowerCase()) }
                                                    value={ rateCode.surchargeCategory?.id }
                                                    onChange={ id => this.onChangeSurchargeCategory(id) }
                                                    style={ { width: '100%' } }
                                                >
                                                    { (tourSurchargeCategories || []).map(item => (
                                                        <AntOption key={ item.id } value={ item.id }>
                                                            { item.name }
                                                        </AntOption>
                                                    )) }
                                                </AntSelect>
                                                <Tooltip title={`${t('action.create')} ${t('item.ratecode.campaign').toLowerCase()}`}>
                                                    <Button type="primary" icon="plus" className="btn-add" onClick={this.onAddItemSurcharge} />
                                                </Tooltip>
                                            </Span>
                                        </FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className='col-md-6'>
                                        <FormWrapperInputComponent
                                            isRequired={ true }
                                            isValidation={ true }
                                            dataValidation={ rateCode.name }
                                            validation={ validation.name }
                                            labelTitle={ t(`item.ratecode.name`) }
                                        >
                                            <MultiLanguageInput
                                                t={t}
                                                name="name"
                                                placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.input') + " " + t("item.ratecode.name")).toLowerCase()) }
                                                value={ rateCode.name ? rateCode.name : "" }
                                                translations={ rateCode.translations }
                                                onChange={ this.onChangeName }
                                            />
                                        </FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className="col-md-6">
                                        <FormWrapperInputComponent
                                            isRequired={ true }
                                            isValidation={ true }
                                            dataValidation={rateCode.productTypes}
                                            validation={validation.productTypes}
                                            labelTitle={t(`item.ratecode.typeGroupSupplier`)}
                                        >
                                            <div className='d-flex justify-content-between flex-column flex-lg-row'>
                                                {
                                                    this.state.isShowVinwonderTypeForUpdate &&
                                                    <div className='ml-3'>
                                                        <label>{t(`item.ratecode.typeGroupSupplierVinwonder`)}</label>
                                                        <CheckboxGroup
                                                            className="ml-3 d-block"
                                                            options={ this.getGroupTypeVinwonder() }
                                                            value={ rateCode.productTypes }
                                                            onChange={ (values)=> this.onChange('productTypes', values)}
                                                        />
                                                    </div>
                                                }
                        
                                                {
                                                    this.state.isShowBasicTypeForUpdate &&
                                                    <div className='ml-3 mt-3 mt-lg-0'>
                                                        <label>{t(`item.ratecode.typeGroupSupplierBasic`)}</label>
                                                        <CheckboxGroup
                                                            className="ml-3 d-block"
                                                            options={ this.getGroupTypeDefind() }
                                                            value={ rateCode.productTypes }
                                                            onChange={ (values)=> this.onChange('productTypes', values)}
                                                        />
                                                    </div>
                                                }
                                            </div>
                                        </FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className='col-md-12'>
                                    <div className='g-mt-10'>
                                            <div className='ml-3 mt-3 mt-lg-0'>
                                                <label>{t(`item.ratecode.minimumUnitConfiguration`)}</label>
                                            </div>
                                            <div className='d-flex flex-column flex-lg-row'>
                                                <Wrapper className='ml-3'>
                                                    <FormWrapperInputComponent
                                                        labelTitle={ t(`item.ratecode.adult`) }
                                                    >
                                                        <Input type="text"
                                                            disabled={this.state.action === "UPDATE"}
                                                            autoComplete="off"
                                                            className="form-control" 
                                                            name="adult" 
                                                            onChange={ (e) => this.onChange('adult', Number(e.target.value)) }
                                                            value={ Func.checkUndefine(rateCode?.adult) }
                                                        />
                                                    </FormWrapperInputComponent>
                                                </Wrapper>
                                                <Wrapper className='ml-3'>
                                                    <FormWrapperInputComponent
                                                        labelTitle={ t(`item.ratecode.child`) }
                                                    >
                                                        <Input type="text"
                                                            disabled={this.state.action === "UPDATE"}
                                                            autoComplete="off"
                                                            className="form-control" 
                                                            name="child" 
                                                            onChange={ (e) => this.onChange('child', Number(e.target.value)) }
                                                            value={ Func.checkUndefine(rateCode?.child) }
                                                        />
                                                    </FormWrapperInputComponent>
                                                </Wrapper>
                                                <Wrapper className='ml-3'>
                                                    <FormWrapperInputComponent
                                                        labelTitle={ t(`item.ratecode.room`) }
                                                    >
                                                        <Input type="text"
                                                            disabled={this.state.action === "UPDATE"}
                                                            autoComplete="off"
                                                            className="form-control" 
                                                            name="room" 
                                                            onChange={ (e) => this.onChange('room', Number(e.target.value)) }
                                                            value={ Func.checkUndefine(rateCode?.room) }
                                                        />
                                                    </FormWrapperInputComponent>
                                                </Wrapper>
                                                <Wrapper className='ml-3'>
                                                    <FormWrapperInputComponent
                                                        isRequired={ this.state.action === "UPDATE"? false : true }
                                                        isValidation={this.state.action === "UPDATE"? false : true }
                                                        dataValidation={rateCode.lengOfStay }
                                                        validation={validation.lengOfStay }
                                                        labelTitle={ t(`item.ratecode.lengOfStay`) }
                                                    >
                                                        
                                                        <Input type="text"
                                                            disabled={this.state.action === "UPDATE"}
                                                            autoComplete="off"
                                                            className="form-control" 
                                                            name="lengOfStay" 
                                                            onChange={ (e) => this.onChange('lengOfStay', Number(e.target.value)) }
                                                            value={ Func.checkUndefine(rateCode?.lengOfStay) }
                                                        />
                                                    </FormWrapperInputComponent>
                                                </Wrapper>
                                            </div>
                                        </div>
                                    </Wrapper>

                                    <Wrapper className='col-md-12'>
                                        <FormWrapperInputComponent
                                            labelTitle={t(`item.ratecode.description`)}
                                        >
                                            <Input.TextArea rows={3} placeholder="" type={`text`}
                                                className='form-control'
                                                name='description' 
                                                onChange={(e) => this.onChange('description', e.target.value)}
                                                value={rateCode.description} 
                                            />
                                        </FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className='col-md-12'>
                                        <RateCodeProducts 
                                            { ...this.props }
                                            arrCodeProducts={rateCode.rateCodeProducts}
                                            addNewProduct={this._onAddNewProduct}
                                            changeInterest={this.onChange}
                                            rateCode={rateCode}
                                            errorRowProduct={this.state.errorRowProduct}
                                        />
                                    </Wrapper>
                                    <Wrapper className='col-md-12 mt-3 right-text-cost'>
                                        <span>{t(`item.ratecode.cost`)}:</span>&nbsp;{Func.formatMoney(costTotal)}
                                    </Wrapper>
                                    <Wrapper className='col-md-12 right-text-cost'>
                                        <span>{t(`item.ratecode.rounding`)}:</span>&nbsp;{Func.formatMoney(rateCode.sellCost - costTotal)}
                                    </Wrapper>
                                    <Wrapper className='col-md-12 mt-3 right-text-cost'>
                                        <span>{t(`item.ratecode.sellCostTitle`)}</span>&nbsp;
                                        <InputNumber 
                                            formatter={value => value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            style={{width: '15%'}}
                                            value={ Func.checkUndefine(rateCode.sellCost) }
                                            onChange={(e)=> this.onChange('sellCost', e)}
                                            min={0}
                                        />
                                        { !isErrorCost && <span className="error-sell-cost">{t(`item.ratecode.errorSellCost`)}</span>}
                                    </Wrapper>
                                    { action === "UPDATE" &&
                                        <Wrapper className='col-md-12 mt-3'>
                                            <SlotServices
                                                t={t}
                                                slotServices={rateCode.slotServices}
                                                onChange={(slotServices) => this.onChange('slotServices', slotServices)}
                                                isShowSync={true}
                                                isSyncing={this.state.isSyncingSlotServices}
                                                onSync={this.onSyncSlotServices}
                                            />
                                        </Wrapper>
                                    }
                                </FormWrapperItem>
                            </Panel>
                            <Panel
                                key="listSchedule"
                                header={
                                    <HeaderComponent
                                    title={t("item.ratecode.listSchedule")}
                                    className="col-md-12"
                                    style={{
                                    userSelect: "none",
                                    paddingTop: "unset",
                                    paddingBottom: "unset",
                                    }}
                                    />
                                }
                            >
                                <Collapse
                                    className="site-collapse-custom-collapse"
                                    expandIconPosition={"right"}
                                >
                                    {rateCodeScheduleWithSellCost.map((el, index) => (
                                        <Panel header={el.lengOfStay + " đêm"} key={el.id} className="site-collapse-custom-panel"
                                            style={{
                                                textAlign: "center",
                                                fontSize: "16px"
                                            }}
                                        >
                                            {this.renderProductList(el)}
                                        </Panel>
                                    ))}
                                </Collapse>
                                {
                                    this.state.isAddNewSchedule === false && <Button onClick={this.onClickAddNewSchedule} disabled={this.state.action === "CREATE"} style={{float: 'right', marginBottom: '20px'}} type="primary">Tạo mới</Button>
                                }
                                <div className='add-new-schedule'>
                                    {this.state.isAddNewSchedule && this.renderAddNewSchedule()}
                                </div>
                            </Panel>
                        </Collapse>
                    </FormActionComponent>
                </PageListComponent>
                <Wrapper className='row'>
                    <Wrapper className="col-lg-12">
                        <StockAvailableTable arrProduct={rateCode.rateCodeProducts}/>
                    </Wrapper>
                </Wrapper>
                    <Alert
                        className='custom-alert'
                        message={t(`item.ratecode.notes`)}
                        type="warning"
                        showIcon
                    />
            </LoadingComponent>
        )
    }

    initDetail() {
        const { match, rateCodeState } = this.props;
        let rateCode = this.state.rateCode;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            this.setState({ action: "UPDATE" });
            rateCode = find(rateCodeState.rateCodes, item => item.id === id) || {adult: 1, child: 0, room: 0, lengOfStay: 1};
            if (rateCode) this.setState({ rateCode });
            this.props.getRateCodeDetail(id);
            this.props.getRateCodeSchedule(id);
        }

        this.props.getRateCodeCampaignList();
        this.props.getAllSupplierProduct();
        this.props.getSupplierAll();
        this.props.getSupplierCategoryListAll();
        this.props.getAllSurchargeCategories();
    }

    _onAddNewProduct = (arrData)=>{
        this.onChange('rateCodeProducts', arrData);
    }

    onChange = (fieldName, value)=>{
        const rateCode = this.state.rateCode;
        if(fieldName === 'campaign'){
            rateCode[fieldName] = { id: value };
        }else{
            rateCode[fieldName] = value;
        }
        if(fieldName === 'code'){
            this.onCheckDefineCode(value);
        }
        if (fieldName === 'interestUnitType') {
            this.recalculatedSchedule(value)
        }
        this.setState({ rateCode });
    }

    onChangeName = (name, translations) => {
        const rateCode = this.state.rateCode;
        rateCode.name = name;
        rateCode.translations = translations;
        this.setState({ rateCode });
    }

    onSyncSlotServices = async () => {
        const { rateCode } = this.state;
        if (!rateCode.id) return;
        this.setState({ isSyncingSlotServices: true });
        try {
            await syncRateCodeSlotServices(rateCode.id, moment().format('YYYY-MM-DD'));
            message.success(this.props.t('item.ratecode.syncSlotServicesSuccess'));
            this.props.getRateCodeDetail(rateCode.id);
        } catch (error) {
            const errorItem = error?.errors?.[0];
            message.error((typeof errorItem === 'string' ? errorItem : errorItem?.message) || error?.message || this.props.t('notification.notInternet'));
        } finally {
            this.setState({ isSyncingSlotServices: false });
        }
    }

    getSubmitRateCodeProducts = () => {
        const { rateCode } = this.state;
        return (rateCode.rateCodeProducts || []).map(item => (
            typeof item?.export === 'function' ? item.export() : omit(item, ['__data__', 'translate', 'translations', 'languageCode', 'languageName'])
        ));
    }

    getSubmitTranslations = () => {
        const { rateCode } = this.state;
        const translations = (rateCode.translations || []).map(item => ({
            id: item.id,
            rateCodeId: item.rateCodeId,
            name: item.name,
            description: item.description,
            languageCode: item.languageCode,
            isDefault: !!item.isDefault
        }));
        let defaultTranslation = find(translations, item => item.isDefault);
        if (!defaultTranslation) {
            defaultTranslation = { languageCode: DEFAULT_LANGUAGE_CODE, isDefault: true };
            translations.push(defaultTranslation);
        }
        defaultTranslation.name = rateCode.name;
        defaultTranslation.description = rateCode.description;
        return translations;
    }

    getSubmitSlotServices = () => {
        const { rateCode } = this.state;
        return (rateCode.slotServices || []).map(slotService => ({
            id: slotService.id,
            rateCodeId: slotService.rateCodeId,
            rateCodeProductId: slotService.rateCodeProductId,
            serviceId: slotService.serviceId,
            translations: (slotService.translations || []).map(item => ({
                id: item.id,
                rateCodeSlotServiceId: item.rateCodeSlotServiceId,
                name: item.name,
                languageCode: item.languageCode,
                isDefault: !!item.isDefault
            }))
        }));
    }

    onChangeSurchargeCategory = (id) => {
        const { tourState } = this.props
        const { tourSurchargeCategories } = tourState
        const rateCode = this.state.rateCode
        const surchargeCategorySelected = tourSurchargeCategories.find(item => item.id === id)
        rateCode.surchargeCategory = surchargeCategorySelected;
        this.setState({ rateCode })
    }

    onCheckDefineCode = (value)=>{
        const { action } = this.state;
        let isCheck = false;
        let length = value.length || 0;
        if(action === 'UPDATE'){
            if(length > 9 || length < 3){
                isCheck = true;
            }
        }
        if(action === 'CREATE'){
            if(length > 5 || length < 3){
                isCheck = true;
            }
        }
        this.setState({typeCheckCode: isCheck});
    }

    onSubmit = (e) => {
        e.preventDefault();
        if (this.validate()) {
            const { rateCode, action, typeCheckCode, errorRowProduct } = this.state;
            let isPass = true;
            let costTotal = 0;
            if(rateCode.rateCodeProducts && rateCode.rateCodeProducts.length > 0){
                costTotal = rateCode.rateCodeProducts.reduce((accumulator, currentValue) => {
                    return accumulator + (currentValue.sellCost || 0)
                }, 0)
            }
            if(costTotal > 0){
                isPass = false;
                if(rateCode.sellCost && rateCode.sellCost > 0){
                    if(rateCode.sellCost - costTotal >= 0){
                        isPass = true;
                    }
                }
            }
            let reqData = {
                ...omit(rateCode, ['__data__', 'translate', 'languageCode', 'languageName']),
                cost: costTotal,
                rounding: rateCode.sellCost - costTotal || 0,
                rateCodeProducts: this.getSubmitRateCodeProducts(),
                translations: this.getSubmitTranslations(),
                slotServices: this.getSubmitSlotServices(),
                minimumUnitShedules: {
                    "adult": rateCode.adult,
                    "child": rateCode.child,
                    "room": rateCode.room,
                    "lengOfStay": rateCode.lengOfStays
                }
            }
            this.setState({isErrorCost: isPass});
            this.onCheckDefineCode(rateCode.code);
            if(action === "CREATE" && isPass && !typeCheckCode && rateCode.code.length <= 5 && rateCode.code.length >= 3){
                    this.props.createRateCodeDetail(reqData);
                    return;
            }
            if(action === "UPDATE" && isPass && !typeCheckCode && rateCode.code.length <= 9 && rateCode.code.length >= 3){
                this.props.updateRateCodeDetail(reqData);
                return;
            }
        }
    };

    onClickBack = () => {
        this.props.history.push(PATHS.RATECODE.LIST.path);
    }

    createRateSchedule = () => {
        const {rateCodeState = {}} = this.props;
        return {
            "rateCodeId": rateCodeState.rateCodeDetail.id,
            "code": rateCodeState.rateCodeDetail.code,
            "name": rateCodeState.rateCodeDetail.name,
            "minimumUnitShedules": {
                "adult": rateCodeState.rateCodeDetail.adult,
                "child": rateCodeState.rateCodeDetail.child,
                "room": rateCodeState.rateCodeDetail.room,
                "lengOfStay": ''
            },
            "rateCodeProduct": (rateCodeState?.rateCodeDetail?.rateCodeProducts || []).map(e => {
                return {
                    ...e,
                    id: rateCodeState.rateCodeDetail.id,
                    "sellCost": 0,
                    "coefficient": 0,
                    oldCoefficient: e.coefficient
                }
            })
        }
    }

    onClickAddNewSchedule = () => {
        this.setState({ isAddNewSchedule: true, newRateCodeSchedule: this.createRateSchedule() })
    }

    validate() {
        const { t } = this.props;
        const { rateCode } = this.state;
        let validate = {
            required: {
                code: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.ratecode.codeTitle`)),
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.ratecode.name`)),

            },
            minLength: {
                productTypes: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.ratecode.productTypes`)),
            },
        };
        if (this.state.action!=="UPDATE") {
            validate.required.lengOfStay = Func.formatValidation(('Lịch trình phải lớn hơn hoặc bằng 1'), t(`item.ratecode.lengOfStay`));
        }
        let valueValidate = {
            minLength: {
                productTypes: 1,
            },
        };
        const errorRowProduct = rateCode.rateCodeProducts.map(e => {
            if (e.isRequired && !e.inventoryDeliveryType) {
                return t('validation.statusCode.code.inventoryDeliveryType.isRequired')
            }
        })
        const result = Func.multipleValidate(this.state.rateCode, validate, valueValidate);
        this.setState({ validation: result, errorRowProduct });
        return Object.keys(result).length < 1 && errorRowProduct.filter(e => e).length < 1;
    }

}